import { useTiersQuery } from './useTiersQuery'

export type Tier = {
  id: number
  title: string
  description: string
  position: number
  status: string
  image?: string
  thumbnail?: string
  membersCount: number
  allowPublishToggle: boolean
  price: number
  discount: boolean
  monthDiscount?: number
  yearDiscount?: number
  timeLimit: boolean
  startDate?: string
  endDate?: string
}

export const useTiers = () => {
  const { tiersQuery } = useTiersQuery()

  const getTiers = (): Tier[] | null => {
    if (!tiersQuery.data?.tiers) return null

    return tiersQuery.data?.tiers
      .map((tier) => {
        return {
          id: tier.id,
          title: tier.name,
          description: tier.description,
          position: tier.position,
          status: tier.status,
          image: tier.image?.url,
          thumbnail: tier.image?.thumbnailUrl,
          membersCount: tier.statistics.membersCount,
          allowPublishToggle: !tier.mobileWlaEnabled,
          price: tier.variants.monthly.amounts.usd.amount / 100,
          discount: !!(tier.discount?.percentOff.monthly || tier.discount?.percentOff.annual),
          monthDiscount: tier.discount?.percentOff.monthly,
          yearDiscount: tier.discount?.percentOff.annual,
          timeLimit: !!(
            tier.discount?.timeLimited?.startTime || tier.discount?.timeLimited?.endTime
          ),
          startDate: tier.discount?.timeLimited?.startTime,
          endDate: tier.discount?.timeLimited?.endTime,
        }
      })
      .sort((a, b) => a.position - b.position)
  }

  return {
    tiersQuery,
    hasAnyTier: tiersQuery.data ? tiersQuery.data.tiers.length > 0 : false,
    tiers: getTiers(),
  }
}
